import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { ERdvIdentificationWidget } from './ERdvIdentificationWidget';
import { ERdvAgencyWidget } from './ERdvAgencyWidget';
import { ERdvDatasWidget } from './ERdvDatasWidget';
import { ERdvComplementaryWidget } from './ERdvComplementaryWidget';
import { ERdvConfirmationWidget } from './ERdvConfirmationWidget';
import { ERdvService } from '../../Services';
import Cookies from 'universal-cookie';
import { ErdvErrors } from '../../Models/Enum/ErdvErrors';

interface IERdvFormWidgetProps {
    description: string;

    dictIdentificationQuestion1Label: string;
    dictIdentificationQuestion2Label: string;
    dictIdentificationQuestionTitle: string;
    dictIdentification101Label: string;
    dictIdentification103Label: string;
    dictIdentification104Label: string;
    dictAgencyTitle: string;
    dictAgencyDesc: string;
    dictTitleLabel: string;
    dictNameLabel: string;
    dictSurnameLabel: string;
    dictNissLabel: string;
    dictPostCodeLabel: string;
    dictPhoneLabel: string;
    dictMailLabel: string;
    dictAgencyLabel: string;
    dictDateLabel: string;
    dictHoursLabel: string;
    dictYesLabel: string;
    dictNoLabel: string;
    dictDatasTitle: string;
    dictNissHelp: string;
    dictMailHelp: string;
    dictTitleMr: string;
    dictTitleMrs: string;
    dictTitleMs: string;
    dictConfirmationTitle1: string;
    dictConfirmationTitle2: string;
    dictConfirmationTitle3: string;
    dictConfirmationDesc1: string;
    dictConfirmationDesc2: string;
    dictConfirmationDesc3: string;
    dictConfirmationDesc4: string;
    dictConfirmationDesc5: string;
    dictConfirmationDesc6: string;
    dictConfirmationDesc7: string;
    dictConfirmationDesc8: string;
    dictConfirmationDesc9: string;
    dictConfirmationDesc10: string;
    dictConfirmationDesc11: string;
    dictComplementaryTitle: string;
    dictComplementaryDesc: string;
    dictCommentaryLabel: string;
    dictCodeRdvLabel: string;
    dictServiceLabel: string;
    dictSiteLabel: string;
    dictConfirmationInfo1: string;
    dictConfirmationInfo2: string;
    dictConfirmationHelp: string;
    dictDateOfBirthLabel: string;
    dictTitleTip1: string;
    dictTitleTip2: string;
    dictDescTip1: string;
    dictDescTip2: string;
    dictNoDateLabel: string;
    dictLockTimeError: string;

    error: ErdvErrors | undefined;
    formStep: number;
    lang: string;
    code: number;
    serviceType: number;
    showValidateButton: (val: boolean) => void;
    handleNavTo: (val: number, errors?: ErdvErrors) => void;
    changeLinks: () => void;
    isNissMandatory: boolean;
    captchaToken?: string | null;
}

interface IERdvFormWidgetState {
    questionsId: boolean[];
    code: { key: number; label: string };
    serviceType: number;
    site: { key: string; label: string };
    service: { key: string; label: string };
    timing: { date: Date; hoursStart: string; hoursEnd: string };
    ressource: { id: number; key: string; type: string };
    user: {
        civilite: number;
        niss: string;
        nom: string;
        prenom: string;
        telephone: string;
        mail: string;
    };
    comment: string;
    visitorUID: string;
}

export class ERdvFormWidget extends Component<
    IERdvFormWidgetProps,
    IERdvFormWidgetState
> {
    constructor(props: IERdvFormWidgetProps) {
        super(props);

        const cookies = new Cookies();
        const visitorUID = cookies.get('visitorUID') ?? '';

        this.state = {
            questionsId: null as any,
            code: { key: this.props.code, label: '' },
            serviceType:
                +this.props.serviceType !== 0
                    ? this.props.serviceType
                    : this.props.lang === 'fr'
                      ? 1
                      : 101,
            site: null as any,
            service: null as any,
            timing: null as any,
            ressource: null as any,
            user: null as any,
            comment: null as any,
            visitorUID: visitorUID.toString(),
        };

        if ('' + this.state.code.key !== '0') {
            void this.setCode(this.state.code.key);
        }
    }

    componentDidMount(): void {
        const cookies = new Cookies();

        if (!cookies.get('visitorUID')) {
            void ERdvService.getVisitorUID()
                .then((result: string) => {
                    cookies.set('visitorUID', result, { path: '/' });
                    this.setState({ visitorUID: result });
                })
                .catch((e: unknown) => {
                    // optional: log / ignore / set error state
                    console.error(e);
                });
        }

        if (String(this.state.code.key) !== '0') {
            void this.setCode(this.state.code.key);
        }
    }

    setCode = async (key: number): Promise<void> => {
        const result = await ERdvService.getMotiveLabel(
            this.state.serviceType,
            key
        );
        this.setState({ code: { key, label: result } });
    };

    setSite = (site: { key: string; label: string }) => {
        this.setState({ site: site });
    };

    setService = (service: { key: string; label: string }) => {
        this.setState({ service: service });
    };

    setTiming = (
        timing: { date: Date; hoursStart: string; hoursEnd: string },
        ressource: { id: number; key: string; type: string }
    ) => {
        this.setState({ ressource: ressource });
        this.setState({ timing: timing });
    };

    setDatas = (datas: {
        title: number;
        name: string;
        surname: string;
        niss: string;
        mail: string;
        phone: string;
    }) => {
        this.setState({
            user: {
                civilite: +datas.title,
                nom: datas.name,
                prenom: datas.surname,
                niss: datas.niss,
                telephone: datas.phone,
                mail: datas.mail,
            },
        });
    };

    setComment = (comment: string) => {
        this.setState({ comment: comment });
    };

    resetDatas = () => {
        this.setState({
            questionsId: null as any,
            code: { key: this.props.code, label: '' },
            serviceType:
                +this.props.serviceType !== 0
                    ? this.props.serviceType
                    : this.props.lang === 'fr'
                      ? 1
                      : 101,
            site: null as any,
            service: null as any,
            timing: null as any,
            ressource: null as any,
            user: null as any,
            comment: null as any,
        });
        this.props.changeLinks();
    };

    render() {
        if (this.props.formStep === 0) {
            return (
                <ERdvIdentificationWidget
                    dictIdentificationQuestionTitle={
                        this.props.dictIdentificationQuestionTitle
                    }
                    dictIdentificationQuestion1Label={
                        this.props.dictIdentificationQuestion1Label
                    }
                    dictIdentificationQuestion2Label={
                        this.props.dictIdentificationQuestion2Label
                    }
                    dictIdentification101Label={
                        this.props.dictIdentification101Label
                    }
                    dictIdentification103Label={
                        this.props.dictIdentification103Label
                    }
                    dictIdentification104Label={
                        this.props.dictIdentification104Label
                    }
                    dictYesLabel={this.props.dictYesLabel}
                    dictNoLabel={this.props.dictNoLabel}
                    lang={this.props.lang}
                    code={this.state.code.key}
                    setCode={(key) => {
                        void this.setCode(key);
                    }}
                    showValidateButton={this.props.showValidateButton}
                ></ERdvIdentificationWidget>
            );
        }
        if (this.props.formStep === 1) {
            return +this.state.code.key !== 0 ? (
                <ERdvAgencyWidget
                    description={this.props.description}
                    dictAgencyLabel={this.props.dictAgencyLabel}
                    dictDateLabel={this.props.dictDateLabel}
                    dictHoursLabel={this.props.dictHoursLabel}
                    dictAgencyTitle={this.props.dictAgencyTitle}
                    dictAgencyDesc={this.props.dictAgencyDesc}
                    dictNoDateLabel={this.props.dictNoDateLabel}
                    dictLockTimeError={this.props.dictLockTimeError}
                    visitorUID={this.state.visitorUID}
                    site={this.state.site}
                    timing={this.state.timing}
                    code={this.state.code.key}
                    setSite={this.setSite}
                    setService={this.setService}
                    setTiming={this.setTiming}
                    lang={this.props.lang}
                    showValidateButton={this.props.showValidateButton}
                    error={this.props.error}
                ></ERdvAgencyWidget>
            ) : null;
        }
        if (this.props.formStep === 2) {
            return (
                <ERdvDatasWidget
                    dictTitleLabel={this.props.dictTitleLabel}
                    dictNameLabel={this.props.dictNameLabel}
                    dictSurnameLabel={this.props.dictSurnameLabel}
                    dictNissLabel={this.props.dictNissLabel}
                    dictPostCodeLabel={this.props.dictPostCodeLabel}
                    dictPhoneLabel={this.props.dictPhoneLabel}
                    dictMailLabel={this.props.dictMailLabel}
                    dictDatasTitle={this.props.dictDatasTitle}
                    dictNissHelp={this.props.dictNissHelp}
                    dictMailHelp={this.props.dictMailHelp}
                    dictTitleMr={this.props.dictTitleMr}
                    dictTitleMrs={this.props.dictTitleMrs}
                    dictTitleMs={this.props.dictTitleMs}
                    dictDateOfBirthLabel={this.props.dictDateOfBirthLabel}
                    dictTitleTip1={this.props.dictTitleTip1}
                    dictTitleTip2={this.props.dictTitleTip2}
                    dictDescTip1={this.props.dictDescTip1}
                    dictDescTip2={this.props.dictDescTip2}
                    user={this.state.user}
                    date={this.state.timing.date}
                    hoursStart={this.state.timing.hoursStart}
                    hoursEnd={this.state.timing.hoursEnd}
                    codeService={this.state.service.key}
                    codeSite={this.state.site.key}
                    ressource={this.state.ressource}
                    visitorUID={this.state.visitorUID}
                    showValidateButton={this.props.showValidateButton}
                    handleNavTo={(val: number, error?: ErdvErrors) =>
                        this.props.handleNavTo(val, error)
                    }
                    setDatas={this.setDatas}
                    code={this.state.code.key}
                    justification={this.state.code.label}
                    timing={
                        this.state.timing.date.toLocaleDateString() +
                        ', ' +
                        this.state.timing.hoursStart
                    }
                    service={this.state.service.label}
                    agency={this.state.site.label}
                    isNissMandatory={this.props.isNissMandatory}
                ></ERdvDatasWidget>
            );
        }
        if (this.props.formStep === 3) {
            return (
                <ERdvComplementaryWidget
                    dictCommentaryLabel={this.props.dictCommentaryLabel}
                    dictComplementaryTitle={this.props.dictComplementaryTitle}
                    dictComplementaryDesc={this.props.dictComplementaryDesc}
                    agency={this.state.site.label}
                    comment={this.state.comment}
                    setComment={this.setComment}
                    justification={this.state.code.label}
                    timing={
                        this.state.timing.date.toLocaleDateString() +
                        ', ' +
                        this.state.timing.hoursStart
                    }
                    service={this.state.service.label}
                ></ERdvComplementaryWidget>
            );
        }
        if (this.props.formStep === 4) {
            if (this.props.captchaToken !== null) {
                return (
                    <ERdvConfirmationWidget
                        dictConfirmationTitle1={
                            this.props.dictConfirmationTitle1
                        }
                        dictConfirmationTitle2={
                            this.props.dictConfirmationTitle2
                        }
                        dictConfirmationTitle3={
                            this.props.dictConfirmationTitle3
                        }
                        dictConfirmationDesc1={this.props.dictConfirmationDesc1}
                        dictConfirmationDesc2={this.props.dictConfirmationDesc2}
                        dictConfirmationDesc3={this.props.dictConfirmationDesc3}
                        dictConfirmationDesc4={this.props.dictConfirmationDesc4}
                        dictConfirmationDesc5={this.props.dictConfirmationDesc5}
                        dictConfirmationDesc6={this.props.dictConfirmationDesc6}
                        dictConfirmationDesc7={this.props.dictConfirmationDesc7}
                        dictConfirmationDesc8={this.props.dictConfirmationDesc8}
                        dictConfirmationDesc9={this.props.dictConfirmationDesc9}
                        dictConfirmationDesc10={
                            this.props.dictConfirmationDesc10
                        }
                        dictConfirmationDesc11={
                            this.props.dictConfirmationDesc11
                        }
                        dictCodeRdvLabel={this.props.dictCodeRdvLabel}
                        dictServiceLabel={this.props.dictServiceLabel}
                        dictSiteLabel={this.props.dictSiteLabel}
                        dictDateLabel={this.props.dictDateLabel}
                        dictHoursLabel={this.props.dictHoursLabel}
                        dictConfirmationInfo1={this.props.dictConfirmationInfo1}
                        dictConfirmationInfo2={this.props.dictConfirmationInfo2}
                        dictConfirmationHelp={this.props.dictConfirmationHelp}
                        dictAgencyDesc={this.props.dictAgencyDesc}
                        dictNameLabel={this.props.dictNameLabel}
                        dictSurnameLabel={this.props.dictSurnameLabel}
                        dictNissLabel={this.props.dictNissLabel}
                        dictPostCodeLabel={this.props.dictPostCodeLabel}
                        dictPhoneLabel={this.props.dictPhoneLabel}
                        dictMailLabel={this.props.dictMailLabel}
                        service={this.state.service}
                        site={this.state.site}
                        timing={this.state.timing}
                        user={this.state.user}
                        comment={this.state.comment}
                        code={this.state.code}
                        ressource={this.state.ressource}
                        lang={this.props.lang}
                        handleNavTo={(val: number, error?: ErdvErrors) =>
                            this.props.handleNavTo(val, error)
                        }
                        resetDatas={this.resetDatas}
                        captchaToken={this.props.captchaToken!}
                    ></ERdvConfirmationWidget>
                );
            } else {
                return <div>error</div>;
            }
        }
        return <div>error</div>;
    }
}

WidgetHelper.register(ERdvFormWidget, 'erdv-form-widget');
